import { render, staticRenderFns } from "./EntryComment.vue?vue&type=template&id=10e3f8c8&scoped=true"
import script from "./EntryComment.vue?vue&type=script&lang=js"
export * from "./EntryComment.vue?vue&type=script&lang=js"
import style0 from "./EntryComment.vue?vue&type=style&index=0&id=10e3f8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e3f8c8",
  null
  
)

export default component.exports